"use client"

import clsx from "clsx"
import { NpButton } from "src/components/np-design/components/button/NpButton"
import { npPageGap2ClassName } from "src/components/np-design/components/constants"
import { NpFeatureGridSection } from "src/components/np-design/sections/features/NpFeatureGridSection"
import { A } from "src/components/unstyled/A"
import { routes } from "src/config/routes"
import { CarouselSlideData } from "src/data/product-details/types"
import { useEventCallback } from "src/hooks/useEventCallback"
import { posthogCapture } from "src/integrations/posthog/events"

export type NpCategoryAccessoriesProps = {
  accessories: { heading: string; slides: CarouselSlideData[] }
}

export const NpCategoryAccessories = ({ accessories }: NpCategoryAccessoriesProps) => {
  const onClick = useEventCallback(() => posthogCapture("to_accessories_clicked"))

  return (
    <div className={clsx(npPageGap2ClassName, "flex flex-col items-center")}>
      <A href={routes.accessories} onClick={onClick}>
        <NpFeatureGridSection heading={accessories.heading} slides={accessories.slides} fit="contain" />
      </A>

      <NpButton href={routes.accessories} onClick={onClick} iconNameRight="arrow_forward">
        Zubehör entdecken
      </NpButton>
    </div>
  )
}
